import { render, staticRenderFns } from "./BuscarTurnos.vue?vue&type=template&id=10347898&scoped=true"
import script from "./BuscarTurnos.vue?vue&type=script&lang=js"
export * from "./BuscarTurnos.vue?vue&type=script&lang=js"
import style0 from "./BuscarTurnos.vue?vue&type=style&index=0&id=10347898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10347898",
  null
  
)

export default component.exports